<v-form @submit.prevent="submitForm" ref="form">
    <v-text-field
        type="password"
        variant="outlined"
        validate-on-blur
        :label="passwordData.label"
        placeholder="Your password"
        :rules="passwordRules"
        v-model="password"></v-text-field>
    <v-text-field
        type="password"
        variant="outlined"
        validate-on-blur
        :label="repeatPasswordData.label"
        placeholder="Confirm your password"
        :rules="repeatPasswordRules"
        v-model="passwordConfirm"></v-text-field>
    <slot></slot>
</v-form>
